export default "__VITE_ASSET__BANSaG8g__"